import styled from "styled-components";

export const PnL = styled.span<{ color?: string }>`
  ${({ color }) => color && `color: ${color};`}
`;
